<template>
  <span :class="`StatusBadge StatusBadge--${status}`">{{ status }}</span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.StatusBadge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;

  &--pending {
    background-color: #fff3cd;
    color: #856404;
  }

  &--accepted {
    background-color: #d4edda;
    color: #155724;
  }

  &--rejected {
    background-color: #f8d7da;
    color: #721c24;
  }
}
</style>
